import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Animated, Easing, Platform, View } from 'react-native';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { SmallView } from '../Typography/SmallView';
import { CoreConfig } from '../../../CoreConfig';
export const CircleProgressView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.circleProgress,
    style(theme) {
        var _a;
        return {
            container: {},
            loader: {
                position: 'absolute',
                borderColor: 'transparent',
                borderWidth: 2,
                borderStyle: 'solid',
                borderTopColor: ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color) || '#000',
            },
            content: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                justifyContent: 'center',
                alignItems: 'center',
            },
            text: {
                fontSize: 8,
            }
        };
    }
})(({ style, height = 20, value, textColor, borderColor, useOutsideBorder, maxValue }) => {
    const animation = useRef(new Animated.Value(0)).current;
    const offset = useOutsideBorder
        ? 3
        : 0;
    const borderRadius = (height / 2) + offset;
    const percent = Math.floor((value / maxValue) * 100);
    useEffect(() => {
        Animated.loop(Animated.timing(animation, {
            toValue: 360,
            duration: 700,
            easing: Easing.in(Easing.linear),
            useNativeDriver: Platform.OS !== 'web'
        })).start();
    }, []);
    const rotate = animation.interpolate({
        inputRange: [0, 360],
        outputRange: ['0deg', '360deg']
    });
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, { width: height, height }], children: [_jsx(Animated.View, { style: [
                    style === null || style === void 0 ? void 0 : style.loader,
                    {
                        top: -offset,
                        left: -offset,
                        right: -offset,
                        bottom: -offset,
                        borderRadius: borderRadius,
                        transform: [{ rotate }]
                    },
                    !!borderColor && { borderTopColor: borderColor }
                ] }), _jsx(View, { style: style === null || style === void 0 ? void 0 : style.content, children: _jsxs(SmallView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, !!textColor && { color: textColor }], children: [percent, "%"] }) })] }));
});
